import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import redirects from "../redirects";

const RedirectMiddleware = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const trackingParams = ["trk", "ref", "pos", "cmd"];
    const hasTracking = trackingParams.some((p) => params.has(p));

    if (hasTracking) {
      navigate("/", { replace: true });
      setChecked(true);
      return;
    }

    const redirectPath = redirects[location.pathname];
    if (redirectPath && redirectPath !== location.pathname) {
      if (redirectPath.startsWith("http")) {
        window.location.href = redirectPath;
        return;
      }
      navigate(redirectPath, { replace: true });
      setChecked(true);
      return;
    }

    setChecked(true);
  }, [location, navigate]);

  if (!checked) return null;

  return children;
};

export default RedirectMiddleware;
